import { FunctionComponent, memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Deeplink,
  DeeplinkType,
  DropdownMenu,
  IconLabel,
  Popup,
  getCssVar,
  layoutPath,
  optArrItem,
} from '../../../../shared';

import dropdownMenuClasses from '../../../../shared/components/DropdownMenu/DropdownMenu.module.scss';
import classes from './StoryMenuAdmin.module.scss';

interface StoryMenuAdminProps {
  storyId: number;
  isReadOnly: boolean;
}

export const StoryMenuAdmin: FunctionComponent<StoryMenuAdminProps> = memo(
  ({ storyId, isReadOnly }) => {
    const { t } = useTranslation();

    const { t: ctxT } = useTranslation('', { keyPrefix: 'integrations' });

    const navigate = useNavigate();

    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

    const setupIntegrationHandler = useCallback(() => {
      setIsMenuOpen(false);
      navigate(layoutPath(`/integrations?storyId=${storyId}&action=setup`));
    }, [navigate, storyId]);

    const integrationInfoHandler = useCallback(() => {
      setIsMenuOpen(false);
      navigate(layoutPath(`/integrations?storyId=${storyId}`));
    }, [navigate, storyId]);

    return (
      <Popup
        isOpen={isMenuOpen}
        setIsOpen={setIsMenuOpen}
        iconId={'dots-menu'}
        ariaLabel={t('common.more-options')}
        color={getCssVar('--action-pane-icon-color')}
        hoverColor={getCssVar('--action-pane-icon-hover-color')}
        parentClassName={classes['story-menu']}
        bodyBottom={'1.5rem'}
        bodyRight={'0'}
        body={
          <DropdownMenu
            width={'12rem'}
            content={[
              <Deeplink
                key={'deeplink'}
                type={DeeplinkType.STORY}
                storyId={storyId}
                onClick={() => setIsMenuOpen(false)}
                className={dropdownMenuClasses['dropdown-menu__item--small']}
              />,
              ...optArrItem(
                !isReadOnly,
                <>
                  <IconLabel
                    iconId={'integration'}
                    iconSize={18}
                    label={ctxT('setup-integration')}
                    onClick={setupIntegrationHandler}
                    className={dropdownMenuClasses['dropdown-menu__item--small']}
                    singleColor
                  />
                  <IconLabel
                    iconId={'info'}
                    iconSize={18}
                    label={ctxT('integration-info')}
                    onClick={integrationInfoHandler}
                    className={dropdownMenuClasses['dropdown-menu__item--small']}
                    singleColor
                  />
                </>
              ),
            ]}
          />
        }
      />
    );
  }
);
